import styled, { css } from 'styled-components';
import ReactSelect from 'react-select';

import { RowStyled, FormGroupStyled } from '~/Components/Styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;

export const Row = styled(RowStyled)`
  justify-content: space-between;
  > label {
    margin-right: 10px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormGroup = styled(FormGroupStyled)`
  flex: 1;
  margin: 0;
  > label{
    > span {
      color: ${props => props.theme.colors.danger2};
      font-weight: normal;
      font-size: 20px;
    }
  }
  .editor-rich {
    border: 2px solid ${props => props.theme.colors.light};
  }
  .invalid-editor {
    border: 2px solid ${props => props.theme.colors.danger2};
  }
  .DraftEditor-editorContainer {
    .public-DraftEditor-content {
      max-height: 109px;
      height: 109px;
    }
  }
`;

export const Questions = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const LabelQuestion = styled.div`
  font-weight: bold;
  color: ${props => props.theme.colors.dark};
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const NewItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AddNewItem = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  ${props => props.disabled && css`
    opacity: 0.7;
  `}

  > a {
    display: flex;
    color: ${props => props.theme.colors.primary};
    font-size: 15px;
    font-weight: bold;
    padding: 10px;
    border: 2px solid ${props => props.theme.colors.primary};
    border-radius: 5px;
    text-decoration: none;
    width: 280px;
    justify-content: center;

    > span {
      margin-top: 0;
      padding-left: 5px;
      color: ${props => props.theme.colors.primary};
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
`;

export const ModalWrapBody = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ModalPreview = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  margin-left: 20px;
`;

export const ModalPreviewTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
  border-bottom: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primaryHex}30;
  height: 50px;
  font-size: 16px;
  padding: 10px;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 580px;
  overflow-y: auto;
  padding: 0 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
`;

export const AddItemsWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.colors.primary};
  border-radius: 5px;
  padding: 5px;
  span {
    font-size: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 5px;
    color: ${props => props.theme.colors.white};
    svg {
      font-size: 16px;
      margin-left: 5px;
      margin-right: 10px;
    }
  }
`;

export const GroupButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.colors.white};
  padding: 5px;
`;

export const ButtonInsert = styled.button.attrs({ type: 'button' })`
  border: 0;
  background-color: transparent;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.white};
  font-size: 20px;
  outline: none;
`;

export const MessageForm = styled.b`
  color: ${props => props.theme.colors.dark};
  font-size: 18px;
`;

export const ButtonEditForm = styled.button.attrs({ type: 'button' })`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.primary};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.primary};
  width: 220px;
  height: 48px;
  font-size: 16px;
  padding: 5px 15px;
  margin: 0px;
  svg {
    margin-left: 10px;
  }
`;

export const ButtonViewForm = styled.button.attrs({ type: 'button' })`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.primary};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.primary};
  width: 220px;
  height: 48px;
  font-size: 16px;
  padding: 5px 15px;
  margin: 0px;
  svg {
    margin-left: 10px;
  }
`;

export const ButtonDeteleForm = styled.button.attrs({ type: 'button' })`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.danger2};
  color: ${props => props.theme.colors.danger2};
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 65px;
  height: 65px;
  font-size: 20px;
  margin: 0;
`;

export const GroupActionsButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const Select = styled(ReactSelect)`
  width: 450px;
  > div {
    border-width: 2px !important;
  }
  ${props => props.invalid
    && css`
      > div {
        border-color: ${props.theme.colors.danger2};
      }
    `}
`;

export const SelectPosition = styled(ReactSelect)`
  width: 200px;
  margin-left: 10px;
  > div {
    border-width: 2px !important;
  }
  ${props => props.invalid
    && css`
      > div {
        border-color: ${props.theme.colors.danger2};
      }
    `}
`;

export const BaseQuestions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .base-header-questions{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const BaseQuestionsContent = styled.div`
  padding: 5px 15px;
  display: flex;
  justify-content: center;
  border: solid 2px ${props => props.theme.colors.light};
  border-radius: 4px;
`;

export const QuestionsList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const QuestionsItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 17px;

  span {
    color: ${props => props.theme.colors.primary};
    padding-top: 3px;
    margin-right: 5px;
    font-weight: bold;
  }

  svg {
    color: ${props => props.theme.colors.primary};
    margin-right: 5px;
    margin-left: 5px;
  }

  p {
    margin-bottom: 0;
    flex: 1;
  }

  & + & {
    border-top: solid 2px ${props => props.theme.colors.light};
  }
`;

export const InfoQuestionNoBenefit = styled.div`
  border: 2px solid #ccc;
  padding: 5px;
  border-radius: 5px;

  p {
    margin-bottom: 0;
    padding-bottom: 0;
    font-size: 13px;
    font-style: italic;
    font-weight: 600;
  }
`;
